import React from "react"
import styled from "styled-components"

const StyledTr = styled.div`
  max-width: 100%;
  display: flex;
  min-height: 3rem;
`
const StyledTdLeft = styled.div`
  display: block;
  padding: 1rem;
  justify-content: center;
  align-items: flex-start;
  min-width: 12rem;
  min-height: 3rem;

  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.03);
`
const StyledTdRight = styled.div`
  display: block;
  padding: 1rem;
  width: 100%;
  min-height: 3rem;
  border: 1px solid rgba(0, 0, 0, 0.03);
  white-space: pre-wrap;
`

type DetailTableRowIF = {
  label: string
  children?: React.ReactNode
}
export const DetailTableRow: React.FC<DetailTableRowIF> = ({
  children,
  label,
  ...props
}) => {
  if (!children) return <></>

  return (
    <StyledTr {...props}>
      <StyledTdLeft>{label}</StyledTdLeft>
      <StyledTdRight>{children}</StyledTdRight>
    </StyledTr>
  )
}
